import type { StyleRule } from '@archipro-design/aria';

export const VariantSelector: StyleRule = () => ({
    [`&:empty`]: {
        display: 'none',
    },
});
